import React, { useEffect, useRef, useState } from "react";
import CheckBox from "../../../UI/CheckBox";
import GtmDataLayer from "../../../../Utility/GtmDataLayer";
import TextArea from "../../../UI/TextArea";

const TriggeredBlame = ({
    clsName,
    onSelectAnswer,
    questArr,
    optionSelected,
    backClick,
    getValues,
    validation
}) => {
    const [showError36, setshowError36] = useState("hide");
    const checkboxRefs = useRef({});
    const [otherText, setOtherText] = useState("hide");
    const [error, setError] = useState("");

    const labelclicked = async (e) => {
        const isValidText = validateText(e);
        const isValidCheckBox = validateCheckBox(e);
        const values = getValues();

        if (isValidText && isValidCheckBox) {
            const reason = values['othertrigger'].trim();
            if (otherText == "show" && reason.length > 3) {
                const index = optionSelected.findIndex(option => option.id === 391);
                if (index !== -1) {
                    optionSelected[index].value = reason;
                } else {
                    optionSelected.push({ id: 391, value: reason });
                }
            }
            onSelectAnswer(e);
        }
    };

    const onSelectOption = (e) => {
        const values = getValues();
        if (e.target.checked === true) {
            setshowError36("hide");
            if (e.target.value != "391") {
                optionSelected.push({ id: +e.target.value });
            }
        } else {
            if (e.target.value == "391") {
                values['othertrigger'] = "";
            }
            let deselect = e.target.value;
            const decre = optionSelected.map((OptionArray, index) => {
                if (deselect == OptionArray.id) {
                    optionSelected.splice(index, 1);
                }
            });
        }
        setOtherText(e.target.value === "391" ? (e.target.checked ? "show" : "hide") : otherText);
    };

    const validateText = (e) => {
        if (otherText == "show") {
            const values = getValues();
            const reason = values['othertrigger'].trim();
            if (reason == "" || reason.length < 3) {
                setError("Please enter");
                return false;
            } else {
                setError("");
                return true;
            }
        } else {
            setError("");
            return true;
        }
    }
    const validateCheckBox = (e) => {
        const values = getValues();
        const reason = values['othertrigger'].trim();
        let selectedCount = optionSelected.length;

        if (selectedCount != 0 || reason.length > 3) {
            setshowError36("hide");
            return true;
        } else {
            setshowError36("show");
            return false;
        }
    }

    let checkArray = questArr.answers;
    const lenderCheckBox = checkArray.map((checArr, index) => {
        return (
            <div className="option_but mb-3" key={checArr.value} ref={(e) => checkboxRefs.current[checArr.value] = e}>
                <div className="odnewscss">
                    <CheckBox
                        dataId={`triggeredblame${checArr.value}`}
                        name="chkBankName[]"
                        onChange={onSelectOption}
                        className=""
                        CheckBoxText={'<span></span>' + checArr.label}
                        value={checArr.value}
                        labelClassName="align-items-center btn-next tick-check-box"
                    />
                </div>
            </div>
        );
    });

    return (
        <>

            <div className={`qsSlider slidea ${clsName}`}>
                <h2 className="qs-title slide-up-now">
                    {" "}
                    If you now believe the lender was responsible for your financial difficulties, what
                    triggered this blame?<br />
                </h2>

                {/* <p className="lbl-fnt">
                    <i>(Select all that applies)</i>
                </p> */}

                <div className="btn-option optinal-items optinal-items-payment pb-3  slide-up-now  ">
                    {lenderCheckBox}

                </div>
                <div className=" option_but ">
                    <TextArea
                        className={`${otherText} custm-txt`}
                        row={4}
                        name="othertrigger"
                        placeholder="Please explain"
                        validation={validation({
                            required: true
                        })}
                    />
                    {error && (
                        <span className="error_msg">{error}</span>
                    )}

                </div>

                <span className={`error_msg ${showError36}`} id="email_err">
                    Please select at least one
                </span>

                <div className="row mb-3 ">
                    <div className="col-12 ">
                        <button
                            type="button"
                            className="btn-comm2 w-100"
                            id="q109"
                            onClick={labelclicked}
                            name="triggeredblame"
                            data-quest-id={126}
                        >
                            Continue
                        </button>

                    </div>

                </div>
                <div className="mt-2 mb-5 text-center">
                    <div>
                        {" "}
                        <button
                            type="button"
                            id="back011"
                            className="back-btn mainbckBtn bi bi-chevron-left"
                            name="blamelender"
                            onClick={backClick}
                        >
                            Back
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TriggeredBlame;